<!--
 * @Author: your name
 * @Date: 2021-12-28 15:26:11
 * @LastEditTime: 2022-01-10 13:56:54
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \petro-web-chemicals-sellerc:\Users\Administrator\Desktop\买家app\petro-app-chemicals-buyer\src\views\mine\personal\SetUp.vue
-->
<template>
  <div class="about-us">
    <Header title="关于我们" :is-nav="true"></Header>
    <div class="about-content">
      <div><van-image width="73" height="70" :src="favicon" /></div>
      <div>中油e化</div>
      <div>{{this.versionName}}</div>
    </div>
    <div class="container-bo">
      <van-cell title="用户协议" is-link to="/userAgreement?id=01" />
    </div>
    <div class="container-bo">
      <van-cell title="隐私政策" is-link to="/userAgreement?id=07" />
    </div>

  </div>
</template>
<script>
import Header from "@/components/Header";
import {getVersion} from "@/common/js/flutterBrid.js";
import favicon from "assets/imgs/favicon.png";

export default {
  components: {
    Header
  },
  data() {
    return {
      show: false,
      favicon: favicon,
      versionName:"1.0.0",
    };
  },
  created() {
    getVersion((result) => {
      console.log("调取设备信息55555",result);
      this.versionName = JSON.parse(result).versionName;
      console.log("设备返回版本666",this.params);
      console.log(this.versionName);
    });
  },
  methods: {

  },
};
</script>
<style lang="stylus" scoped>
.about-us {
  background: #FFF;
  height: 100vh;

  .about-content {
    margin-top: 44px;
    margin-bottom: 30px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    div:nth-child(2) {
      margin: 44px 0 28px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 36px;
      color: #333333;
    }

    div:nth-child(3) {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 28px;
      color: #333333;
    }
  }

  .container-bo {
    // padding: 0 40px;
    margin: 0 40px;
    border-bottom: 1px solid #ccc;

    .van-cell__title, .van-cell__right-icon {
      height: 86px;
      line-height: 96px;
      font-weight: 400;
      font-size: 28px;
      color: #333333;
    }
  }
}
</style>
